import React from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { img_collapse, img_expand } from '../../../../utils/ImagesManagementUtils';

//= ========================================================================

const ExpendArrowBtn = ({
  onPress,
  expendDetails,
  style,
}) => (
  <TouchableOpacity style={style} onPress={onPress}>
    <Image
      fadeDuration={0}
      style={{ width: 10, height: 10 }}
      source={expendDetails ? img_expand : img_collapse}
    />
  </TouchableOpacity>
);
export default ExpendArrowBtn;
